import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-black container mx-auto p-8 text-center",
  style: {"font-family":"'Times New Roman'"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-2xl" }, " Kişisel Verilerin Korunması Mevzuatı Uyarınca ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-2xl" }, " CheckUp Hizmeti Alan Müşterilere Yönelik Kişisel Verilerin İşlenmesine İlişkin Açık Rıza Metni ", -1)
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) gereğince, kişisel verilerimin Binovative İnovasyon Danışmanlık A.Ş. (“Binovative A.Ş.”) tarafından, hangi amaçla işleneceği, işlenen kişisel verilerin kimlere ve hangi amaçla aktarılabileceği, kişisel veri toplamanın yöntemi ve hukuki sebebi ve KVKK’nın 11. maddesinde sayılan diğer haklarım hususlarında ilişkin KVKK ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Aydınlatma Metni")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" başlığı altında okudum, bilgilendim. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Bu kapsamda, tarafıma gerekli aydınlatmanın yapıldığını, işbu metni, Kişisel Verilerin Korunması Kanunu uyarınca ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Aydınlatma Metni")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("’ni okuduğumu ve anladığımı kabul ederek, kimlik bilgileri ve sair kişisel verilerimin Binovative A.Ş. tarafından sağlanan hizmetleri, ürün ve hizmetlere ilişkin yönlendirmede bulunulması, kampanyalara ilişkin bilgi verilebilmesi, anılan hizmetlere ve ürünlere yönelik tanıtım, pazarlama ve kampanya faaliyetlerinin sosyal medya, arama motorları vb. çeşitli kanallarla gerçekleştirilmesi ve bu amaçlarla verilerimin her türlü platformda muhafaza edilmesini, Binovative A.Ş. nezdindeki her türlü hizmetten faydalanabilmem, tanıtımının yapılması, pazarlaması ve satışı için her türlü iletişim aracı ve kanalla bilgilendirme yapılması ve hizmetin tanıtımı için kişisel verilerimin her türlü platformda muhafaza edilmesi ve Binovative A.Ş. online CheckUp hizmetine katılmam halinde web-sitesi ve online hizmetlerinin geliştirilebilmesi amacıyla yukarıda belirtilen bilgiler kapsamında işlenmesine rıza gösteriyorum. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: '/agreements/binovative_kvkk_aydinlatma_metni.pdf',
        target: "_blank",
        class: "underline italic text-black"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_7
    ]),
    _createElementVNode("p", null, [
      _hoisted_8,
      _createVNode(_component_router_link, {
        to: '/agreements/binovative_kvkk_aydinlatma_metni.pdf',
        target: "_blank",
        class: "underline italic text-black"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_10
    ])
  ]))
}